import React, { Component } from 'react';
import { Dialog, DialogActions, DialogContent, Grid, Step, StepLabel, Stepper, List, Paper, Checkbox, TableCell, TableRow, TableBody, TableHead, Table, TableContainer, Button, Tooltip, Typography, Chip, Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import AppBarModal from '../../general/AppBarModal';
import TareasTerminadas from '../../general/TareasTerminadas';
import ConfirmarAccion from '../../general/ConfirmarAccion';
import emma_w from '../../../global/imagenes/emma_w.png';
import { BtnCancelar, BtnCargar, BtnDescargar, BtnDetalle, BtnForm } from '../../general/BotonesAccion';
import { crear_form_data, formulario, mostrarError, obtenerPermisosValorAlt, obtenerValoresFiltros, validateInputs, consulta } from '../../../global/js/funciones';
import moment from 'moment';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PublishIcon from '@material-ui/icons/Publish';
import { AgregarActividad, AgregarFinanciacion, AgregarInfoBasica, AgregarInstitucion, AgregarParticipante, AgregarParticipanteMasivo, DetalleParticipante, ModalContenedor } from './forms/Forms';
import { CODIGO_CURSO_CORTO, CODIGO_CURSO_CORTO_PROFE, CODIGO_NO_APLICA_TIPO_SUBACTIVIDAD, CODIGO_TIPO_CONCEPTO_OTRO, DEPARTAMENTO_RESPONSABLE, DEPENDENCIAS_FINANCIACIONES_MOVILIDAD, DPTO_ADMINISTRATIVO, FACULTAD_POSGRADOS_PARTICI, FACULTAD_RESPONSABLE, FUENTES_FINANCIACIONES_MOVILIDAD, MASIVOS_INTER, MODALIDADES_VIRTUALES, OTRA_PLATAFORMA, PROGRAMAS, REQUISITOS_MOV, SUBTIPOS_ACTIVIDADES_MOVILIDAD, SUBTIPO_ACTI_ACADEMICO, SUBTIPO_ACTI_EMPRESARIAL, TIPOS_ACTIVIDADES_MOVILIDAD, TIPOS_CONCEPTOS_MOV, TIPOS_FINANCIACIONES_MOVILIDAD, TIPOS_FORMS_MOVILIDAD, TIPOS_IDENTICACION, TIPOS_MODALIDADES, TIPOS_MOVILIDADES, TIPOS_MOV_ENTRANTES, TIPOS_MOV_SALIENTES, TIPOS_NIVELES_EDU, TIPOS_PARTICIPANTES, TIPOS_PLATAFORMAS, TIPO_FIN_INSTITUCIONAL, TIPO_FIN_INTERNACIONAL, TIPO_FIN_NACIONAL, TIPO_MOVILIDADES_PROFESOR, TIPO_MOV_DOCENTE, TIPO_MOV_ESTUDIANTE, TIPO_PARTICIPANTE_ADMIN, TIPO_PARTICIPANTE_DOC, TIPO_PARTICIPANTE_ESTU, TIPO_RESPONSABLE, UNIDAD_ADMIN_RESPONSABLE } from './helper';
import AddIcon from '@material-ui/icons/Add';
import emma_s1 from '../../../global/imagenes/emma_s1.png';
import { CURRENCIES } from '../currencies';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import EnviarMultiplesArchivos from '../../general/EnviarMultiplesArchivos';
import InfoIcon from '@material-ui/icons/Info';

const configStep = ['Actividad', 'Participantes', 'Evidencias'];

const styles = {
  // flexCenter: {
  //   textAlign: "center",
  //   marginTop: "5px"
  // },
  colorEmmma: {
    color: "#c79e32",
    transition: 'all 0.3s',
    '&:hover': {
      color: "#fff",
      backgroundColor: "#c79e32",
      transform: "scale(1.3)",
    },
  },
  colorDelete: {
    color: "#d11a2a",
    transition: "all 0.3s",
    '&:hover': {
      color: "#fff",
      backgroundColor: "#d11a2a",
      transform: "scale(1.3)",
    },
  }
}


class RegistroCrear extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrarForm: false,
      cargando: false,
      cargandoForm: false,
      cargandoContenedor: false,
      enviando: false,
      tit_cargando: 'Cargando..',
      activeStep: 0,
      selectAll: false,
      datosParticipante: {
        primer_nombre: '',
        segundo_nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        tipo_identificacion: '',
        identificacion: '',
        nacionalidad: '',
        celular: '',
        correo_personal: '',
        correo: '',
        indicativo_celular: ''
      },
      participantes: [],
      participantesSelect: [],
      participanteDetalle: {},
      errores: [],
      participante_quitar: 0,
      participante_tipo: null,
      error: false,
      ident_tipo_movilidad: null,

      // INFO BASICA
      tipo_movilidad: '',
      tipo_modalidad: '',
      plataforma: '',
      otra_plataforma: '',

      // ACTIVIDAD
      tipo_actividad: '',
      otro_tipo_actividad: '',
      subtipo_actividad: '',
      otro_subtipo_actividad: '',
      institucion_seleccionada: '',
      // horas: '',
      fecha_inicio: null,
      fecha_fin: null,
      responsable_actividad: [],
      dpto_responsable: [],
      facultad_responsable: [],
      administrativos_responsable: [],
      titulo_tema: '',
      descripcion_actividad: '',
      resultados_descripcion: '',
      info_complementaria: '',
      info_complementaria_f: '',
      instituciones: [],
      departamento_docente: '',
      programa_docente: '',

      // FINANCIACIÓN
      mostrarFormulario: true,
      financiaciones: [],
      nuevaFinanciacion: {
        tipo_financiacion: '',
        dependencia: '',
        fuente_financiacion: '',
        entidad: '',
        valor_cop: '',
        tipo_moneda: '',
        valor_ext: '',
        clasificacion_de_financiacion: '',
        otro_tipo_de_concepto: '',
      },
      es_financiado: '',
      tipo_financiacion: '',
      dependencia: '',
      fuente_financiacion: '',
      entidad: '',
      valor_cop: '',
      tipo_moneda: '',
      valor_ext: '',
      clasificacion_de_financiacion: '',
      otro_tipo_de_concepto: '',
      comprobante_financiacion: '',

      // INSTITUCION
      institucion_participante: { id: 0, institucion: '', pais: '', ciudad: '' },
      tipo_participante: null,
      dpto_participante: '',
      programa_participante: '',
      facultad_participante: '',
      nivel_participante: '',


      // CONSULTA GENERAL
      tipos_movilidades_all: [],

      // CONSULTAS
      tipos_forms: [],
      tipos_identificacion: [],
      tipos_movilidades: [],
      tipos_modalidades: [],
      plataformas: [],
      tipos_actividades: [],
      subtipos_actividades: [],
      tipos_responsables: [],
      departamentos_resp: [],
      facultades_resp: [],
      administrativos_resp: [],
      tipos_financiaciones: [],
      dependencias: [],
      fuentes_financiacion: [],
      monedas: [],
      tipos_conceptos: [],
      tipos_participantes: [],
      dptos_academicos: [],
      niveles_educativos: [],
      programas_receptores: [],
      programas_receptores_docente: [],
      evidencias: [],
      masivos: [],
      programas_docente: [],
      periodos: [],
      periodoSeleccionado: '',


      // DATOS MULTIPLES
      info_inicial_participantes: [],
      actividad_participantes: [],
      financiacion_participantes: [],
      institucion_participantes: [],




      // MODALES
      modalAddParticipante: false,
      modalDelParticipante: false,
      modalContenedor: false,
      modalAddInfoBasica: false,
      modalAddActividad: false,
      modalAddFinanciacion: false,
      modalAddInstitucion: false,
      modalAddEvidencia: false,
      modalAddParticipanteMasivo: false,
      modalDetParticipante: false,
      modal_buscar_institucion: false,
      modal_quitar_institucion: false,
      modal_elimi_institucion: false,
      modalAddParticipantExt: false,

      //Borrador
      borradorActividad: [],
      modalSeguirBorrador: false,
      modalDelBorrador: false,
      borradorEliminar: {},
      cargandoBorrador: false,
      msgCargandoBorrador: '',
      isBorrador: false,
      solicitudSelect: {},
      info_complementaria_url: "",
      id_solicitud_borrador: 0,
      pertenece_red_academica: '',
      redesAcademicas: [],
      redAcademicaSelect: null
    }
    // ARCHIVOS
    this.fileInput = React.createRef();  
  }

  async componentDidMount() {
    let tipos_movilidades_all = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_MOVILIDADES }, { 'llave': 'estado', 'valor': 1 }]);
    let tipos_identificacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_IDENTICACION }, { 'llave': 'estado', 'valor': 1 }]);
    let masivos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': MASIVOS_INTER }, { 'llave': 'estado', 'valor': 1 }]);
    this.setState({ tipos_movilidades_all, masivos, tipos_identificacion });
  }

  async componentDidUpdate(prevProps, prevState) {
    let { modalAddParticipante, modalAddInfoBasica, modalContenedor, es_financiado, mostrarForm, tipo_actividad, subtipo_actividad, tipo_movilidad, modalAddInstitucion, participantesSelect, info_inicial_participantes, tipo_participante, facultad_participante, nivel_participante, niveles_educativos, dpto_participante, activeStep, departamento_docente, nuevaFinanciacion, isBorrador } = this.state
    let { modalAddRegistro, tipo_solicitud } = this.props

    // MOSTRAR FORMULARIO DE ACTIVIDAD ✅
    if (prevState.mostrarForm !== mostrarForm) {
      if (modalAddRegistro && mostrarForm) {
        this.setState({ cargandoForm: true });
        // let tipos_identificacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_IDENTICACION }, { 'llave': 'estado', 'valor': 1 }]);
        let tipos_actividades = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_ACTIVIDADES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valora', 'valor': '1' }]);
        let tipos_responsables = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPO_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }]);
        let administrativos_resp = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': UNIDAD_ADMIN_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }]);
        let departamentos_resp = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DEPARTAMENTO_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valorg', 'valor': '1' }]);
        let facultades_resp = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': FACULTAD_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }]);
        let periodos = await this.obtenerGeneracionPeriodos();
        let redesAcademicas = await this.obtenerRedesAcademicas();
        this.setState({ tipos_actividades, cargandoForm: false, tipos_responsables, administrativos_resp, departamentos_resp, facultades_resp, periodos, redesAcademicas });
      }
    }

    // TIPO DE ACTIVIDAD
    // LIMPIAR MOVILIDAD Y MODALIDAD???????
    if (prevState.tipo_actividad !== tipo_actividad) {
      // if (this.state.isBorrador) {
      //   this.setState({ cargandoForm: false, subtipo_actividad });
      //   return;
      // }
      if (tipo_actividad) {
        this.setState({ cargandoForm: true, otro_tipo_actividad: '', otro_subtipo_actividad: '' });
        // OBTENER SUBTIPOS DE ACTIVIDADES DE ACUERDO AL TIPO DE ACTIVIDAD
        let subtipos_actividades = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': tipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': SUBTIPOS_ACTIVIDADES_MOVILIDAD }, { 'llave': 'secundario__valora', 'valor': '1' }]);
        // ⚠️ secundario valora es para las subactividades que se deben mostrar en el formulario

        const tieneSubtiposReales = subtipos_actividades.some(item => 
          item.secundario.codigo !== CODIGO_NO_APLICA_TIPO_SUBACTIVIDAD
        );

        // ⚠️ EXISTEN ACTIVIDADES QUE NO TIENEN SUBTIPOS, SIN EMBARGO SE LE RELACIONA UNA SUBACTIVIDAD QUE (NO APLICA) PARA TENER LOS PERMISOS DE MOVILIDAD Y MODALIDAD
        const nuevoSubtipo = subtipos_actividades.some(item => item.secundario.codigo === CODIGO_NO_APLICA_TIPO_SUBACTIVIDAD) ? CODIGO_NO_APLICA_TIPO_SUBACTIVIDAD : '';

        if (!isBorrador){
          this.setState({
            subtipos_actividades,
            cargandoForm: false,
            otro_subtipo_actividad: '',
            subtipo_actividad: tieneSubtiposReales ? '' : nuevoSubtipo
          });
        } else {
          this.setState({
            subtipos_actividades,
            cargandoForm: false,
            otro_subtipo_actividad: ''
          });
        }
       
      }
    }

    // SUBTIPO DE ACTIVIDAD ✅
    if (prevState.subtipo_actividad !== subtipo_actividad && subtipo_actividad) {
      this.setState({ cargandoForm: true });

      let modalidadActividad, modalidadSubActividad, tipo_movilidad_act, tipo_movilidad_subact;
      //console.log("hola")

      // ⚠️ SI EL TIPO DE ACTIVIDAD ES CURSO CORTO Y EL SUBTIPO ES EMPRESARIAL, SE DEBE MOSTRAR LAS MODALIDADES DE PROFESOR
      // SI NO, SE DEBEN MOSTRAR LAS MODALIDADES DE ACUERDO AL TIPO DE ACTIVIDAD Y SUBTIPO DE ACTIVIDAD
      if (tipo_actividad === CODIGO_CURSO_CORTO && subtipo_actividad === SUBTIPO_ACTI_EMPRESARIAL) {
        modalidadActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': CODIGO_CURSO_CORTO_PROFE }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
        tipo_movilidad_act = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': CODIGO_CURSO_CORTO_PROFE }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MOVILIDADES }]);
      } else {
        // ⚠️ CONSULTA DE MODALIDADES DE ACUERDO AL TIPO DE ACTIVIDAD
        modalidadActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': tipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
        // ⚠️ CONSULTA DE TIPOS DE MOVILIDADES DE ACUERDO AL TIPO DE ACTIVIDAD
        tipo_movilidad_act = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': tipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MOVILIDADES }]);
      }

      // ⚠️ CONSULTA DE MODALIDADES DE ACUERDO AL SUBTIPO DE ACTIVIDAD
      modalidadSubActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': subtipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
      // ⚠️ CONSULTA DE TIPOS DE MOVILIDADES DE ACUERDO AL SUBTIPO DE ACTIVIDAD
      tipo_movilidad_subact = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': subtipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MOVILIDADES }]);

      // ⚠️ CRUCE ENTRE MODALIDAD DE ACTIVIDAD Y MODALIDAD DE SUBACTIVIDAD PARA OBTENER LAS MODALIDADES QUE SE DEBEN MOSTRAR
      const coincidencias_modalidad = modalidadActividad.filter(obj1 => modalidadSubActividad.some(obj2 => obj1.secundario.id === obj2.secundario.id));
      // ⚠️ CRUCE ENTRE TIPO DE MOVILIDAD DE ACTIVIDAD Y TIPO DE MOVILIDAD DE SUBACTIVIDAD PARA OBTENER LOS TIPOS DE MOVILIDADES QUE SE DEBEN MOSTRAR
      const coincidencias_movilidad = tipo_movilidad_act.filter(obj1 => tipo_movilidad_subact.some(obj2 => obj1.secundario.id === obj2.secundario.id));

      this.setState({ tipos_modalidades: coincidencias_modalidad, tipos_movilidades: coincidencias_movilidad, cargandoForm: false });
    }

    // MODAL CONTENEDOR ✅
    if (prevState.modalContenedor !== modalContenedor) {
      if (modalContenedor) {
        this.setState({ cargandoContenedor: true });
        let tipos_forms = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_FORMS_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }, {'llave': 'valora', 'valor': '1'}]);
        this.setState({ tipos_forms, cargandoContenedor: false });
      }
      if (!modalContenedor) this.setState({ tipos_forms: [] });
    }

    // MODAL ADD PARTICIPANTE ✅
    if (prevState.modalAddParticipante !== modalAddParticipante) {
      // if (modalAddParticipante) {
      //   this.setState({ cargandoForm: true });
      //   let tipos_identificacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_IDENTICACION }, { 'llave': 'estado', 'valor': 1 }]);
      //   this.setState({ tipos_identificacion, cargandoForm: false })
      // }
      if (!modalAddParticipante) this.resetForm('participante');
    }

    // if (prevState.participantes !== participantes) {
    //   let ultimoObjeto = participantes[participantes.length - 1];
    //   if (ultimoObjeto !== undefined) {
    //     console.log(ultimoObjeto)
    //     if (ultimoObjeto.id !== participantes.length) {
    //       participantes.forEach((participante, index) => { participante.id = index + 1 });
    //       this.setState({ participantes });
    //     }
    //   }
    // }

    if (prevState.modalAddInfoBasica !== modalAddInfoBasica) {
      if (modalAddInfoBasica) {
        this.setState({ cargandoForm: true });
        let tipos_plataformas = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_PLATAFORMAS }, { 'llave': 'estado', 'valor': 1 }]);
        this.setState({ plataformas: tipos_plataformas, cargandoForm: false });
      }
      if (!modalAddInfoBasica) this.resetForm('info_basica');
    }


    if (prevState.es_financiado !== es_financiado) {
      if (es_financiado === '1') {
        this.setState({ cargandoForm: true });
        let tipos_financiaciones = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_FINANCIACIONES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }]);
        let tipos_conceptos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_CONCEPTOS_MOV }, { 'llave': 'estado', 'valor': 1 }]);
        let monedas = CURRENCIES
        this.setState({ tipos_financiaciones, monedas, tipos_conceptos, cargandoForm: false });
      } else {
        this.setState({ nuevaFinanciacion: { tipo_financiacion: '', dependencia: '', fuente_financiacion: '', entidad: '', valor_cop: '', tipo_moneda: '', valor_ext: '', clasificacion_de_financiacion: '', otro_tipo_de_concepto: '' }, mostrarFormulario: true });
      }
    }

    if (prevState.nuevaFinanciacion.tipo_financiacion !== nuevaFinanciacion.tipo_financiacion) {
      if (nuevaFinanciacion.tipo_financiacion == TIPO_FIN_NACIONAL) {
        this.setState({ cargandoForm: true });
        let fuentes_financiacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': FUENTES_FINANCIACIONES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valora', 'valor': 'nacional' }]);
        this.setState({ fuentes_financiacion, cargandoForm: false });
      } else if (nuevaFinanciacion.tipo_financiacion == TIPO_FIN_INTERNACIONAL) {
        this.setState({ cargandoForm: true });
        let fuentes_financiacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': FUENTES_FINANCIACIONES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valora', 'valor': 'internacional' }]);
        this.setState({ fuentes_financiacion, cargandoForm: false });
      } else {
        this.setState({ cargandoForm: true });
        let dependencias = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DEPENDENCIAS_FINANCIACIONES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }]);
        this.setState({ dependencias, cargandoForm: false });
      }
    }

    if (prevState.tipo_movilidad !== tipo_movilidad && tipo_movilidad) {
      let modalidadActividad, modalidadSubActividad;
      this.setState({ cargandoForm: true });
      if (tipo_actividad === CODIGO_CURSO_CORTO && subtipo_actividad === SUBTIPO_ACTI_ACADEMICO && TIPO_MOVILIDADES_PROFESOR.includes(tipo_movilidad)) {
        modalidadActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': CODIGO_CURSO_CORTO }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
        modalidadSubActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': 'Academico_subtipo_actividad_profesor' }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
      } else {
        modalidadActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': tipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
        modalidadSubActividad = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': subtipo_actividad }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': TIPOS_MODALIDADES }]);
      }
      const coincidencias = modalidadActividad.filter(obj1 => modalidadSubActividad.some(obj2 => obj1.secundario.id === obj2.secundario.id));
      this.setState({ tipos_modalidades: coincidencias, cargandoForm: false });
    }

    if (prevState.modalAddInstitucion !== modalAddInstitucion) {
      if (modalAddInstitucion) {
        let error = false;
        this.setState({ cargandoForm: true, error: false, participante_tipo: null, tipos_participantes: [], tipo_participante: null });
        const participantesSeleccionados = participantesSelect.map(participante => participante.identificacion);
        //console.log(participantesSeleccionados)
        const informacionParticipantesSeleccionados = info_inicial_participantes.filter(participante => {
          return participante.participantes.some(identificacion => participantesSeleccionados.includes(identificacion));
        });
        //console.log(informacionParticipantesSeleccionados)

        if (informacionParticipantesSeleccionados.length === 0) {
          //console.log('error')
          error = true;
          this.setState({ error: true })
        }

        if (!error) {
          let tiposMovilidad = [];
          if (informacionParticipantesSeleccionados.length > 0) {
            tiposMovilidad = informacionParticipantesSeleccionados.map(participante => participante.tipo_movilidad);
          }

          // Verificar si todos los tipos de movilidad son iguales
          const sonIguales = tiposMovilidad.every(tipo => tipo === tiposMovilidad[0]);

          // Verificar si todos los tipos de movilidad corresponden a estudiantes
          const sonEstudiantes = tiposMovilidad.length > 0 ? tiposMovilidad.every(tipo => TIPO_MOV_ESTUDIANTE.includes(tipo)) : false;

          // Verificar si todos los tipos de movilidad corresponden a docentes
          const sonDocentes = tiposMovilidad.length > 0 ? tiposMovilidad.every(tipo => TIPO_MOV_DOCENTE.includes(tipo)) : false;

          // Verificar si todos los tipos de movilidad corresponden a salientes
          const sonSalientes = tiposMovilidad.length > 0 ? tiposMovilidad.every(tipo => TIPOS_MOV_SALIENTES.includes(tipo)) : false;

          // Verificar si todos los tipos de movilidad corresponden a entrantes
          const sonEntrantes = tiposMovilidad.length > 0 ? tiposMovilidad.every(tipo => TIPOS_MOV_ENTRANTES.includes(tipo)) : false;

          let tipos_participantes = [];
          if (sonEstudiantes) {
            tipos_participantes = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_PARTICIPANTES }, { 'llave': 'valora', 'valor': 1 }, { 'llave': 'estado', 'valor': 1 }]);
            this.setState({ participante_tipo: true, tipos_participantes, tipo_participante: tipos_participantes[0].id });
          } else if (sonDocentes) {
            tipos_participantes = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_PARTICIPANTES }, { 'llave': 'valora', 'valor': 0 }, { 'llave': 'estado', 'valor': 1 }]);
            this.setState({ participante_tipo: false, tipos_participantes });
          } else {
            this.setState({ participante_tipo: 'distinto' });
          }

          if (sonSalientes) this.setState({ ident_tipo_movilidad: 'saliente' })
          else if (sonEntrantes) this.setState({ ident_tipo_movilidad: 'entrante' })
          else this.setState({ ident_tipo_movilidad: 'distinto' })
        }

        this.setState({ cargandoForm: false });
      }
      if (!modalAddInstitucion) this.resetForm('institucion');
    }

    if (prevState.tipo_participante !== tipo_participante) {
      if (tipo_participante) {
        this.setState({ cargandoForm: true });
        this.setState({ dpto_participante: '', programa_participante: '', facultad_participante: '', facultades_resp: [], dptos_academicos: [], dependencias: [] });

        if (tipo_participante == TIPO_PARTICIPANTE_ESTU) {
          let facultades_resp = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': FACULTAD_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }]);
          this.setState({ facultades_resp });
        }


        if (tipo_participante == TIPO_PARTICIPANTE_DOC) {
          let dptos_academicos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DEPARTAMENTO_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valorc', 'valor': 'docente' }]);
          this.setState({ dptos_academicos });

        } else if (tipo_participante == TIPO_PARTICIPANTE_ADMIN) {
          let dptos_academicos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DEPARTAMENTO_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valorc', 'valor': 'administrativo' }]);
          let dependencias = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DEPENDENCIAS_FINANCIACIONES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }]);
          this.setState({ dptos_academicos, dependencias });
        }
        this.setState({ cargandoForm: false });
      }
    }

    if (prevState.facultad_participante !== facultad_participante) {
      if (facultad_participante) {
        this.setState({ cargandoForm: true, nivel_participante: '' });
        if (facultad_participante == FACULTAD_POSGRADOS_PARTICI) {
          let niveles_educativos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_NIVELES_EDU }, { 'llave': 'valora', 'valor': 'posgrado' }, { 'llave': 'estado', 'valor': 1 }]);
          this.setState({ niveles_educativos });
        } else {
          let niveles_educativos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_NIVELES_EDU }, { 'llave': 'valora', 'valor': 'pregrado' }, { 'llave': 'estado', 'valor': 1 }]);
          this.setState({ niveles_educativos });
        }
        this.setState({ cargandoForm: false });
      }
    }

    if (prevState.facultad_participante !== facultad_participante || prevState.nivel_participante !== nivel_participante) {
      if (facultad_participante && nivel_participante) {
        this.setState({ cargandoForm: true });
        let permisos_programas = await obtenerPermisosValorAlt([{ 'llave': 'principal', 'valor': facultad_participante }, { 'llave': 'secundario__generica', 'valor': PROGRAMAS }]);
        let programas_receptores = [];
        let nivel = niveles_educativos.find(({ id }) => id == nivel_participante).nombre.toLowerCase();
        if (nivel && nivel == 'pregrado') programas_receptores = permisos_programas.filter(programa => programa.secundario.valorc == nivel).map(programa => programa.secundario); // Trae programas asociados a la facultad y al nivel educativo seleccionado (pregrado).
        else programas_receptores = permisos_programas.filter(programa => programa.secundario.valord == nivel).map(programa => programa.secundario); // Trae programas asociados a la facultad y al nivel educativo seleccionado (posgrados).
        this.setState({ cargandoForm: false, programas_receptores });
      }
    }

    if (prevState.dpto_participante !== dpto_participante) {
      if (dpto_participante) {
        if (tipo_participante == TIPO_PARTICIPANTE_DOC) {
          this.setState({ cargandoForm: true });
          let programas_receptores_docente = await obtenerPermisosValorAlt([{ 'llave': 'principal', 'valor': dpto_participante }, { 'llave': 'secundario__generica', 'valor': PROGRAMAS }]);
          this.setState({ programas_receptores_docente, cargandoForm: false });
        }
      }
    }


    if (prevState.activeStep !== activeStep) {
      if (activeStep) {
        if (activeStep === 2) {
          this.setState({ cargandoForm: true });
          let evidencias = await obtenerPermisosValorAlt([{ 'llave': 'principal', 'valor': tipo_solicitud }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'secundario__generica', 'valor': REQUISITOS_MOV }]);
          //console.log(evidencias)
          this.setState({ evidencias, cargandoForm: false });
        }
      }
    }

    if (prevState.departamento_docente !== departamento_docente) {
      if (departamento_docente) {
        this.setState({ cargandoForm: true });
        let programas_docente = [];
        if (departamento_docente == DPTO_ADMINISTRATIVO) {
          let facultades = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': FACULTAD_RESPONSABLE }, { 'llave': 'estado', 'valor': 1 }]);
          let dependencias = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DEPENDENCIAS_FINANCIACIONES_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }])
          programas_docente=[...facultades, ...dependencias];
          programas_docente.sort((a, b) => {
            //console.log(a, b)
          });
        }
        else programas_docente = await obtenerPermisosValorAlt([{ 'llave': 'principal', 'valor': departamento_docente }, { 'llave': 'secundario__generica', 'valor': PROGRAMAS }]);
        this.setState({ programas_docente, cargandoForm: false });
      }
    }

  }

  obtenerGeneracionPeriodos = () => {
      return new Promise(resolve => {
        consulta(`api/v1.0/internacionalizacion/registro/generarPeriodos`, null, null,
          (error, estado, resp) => {
            resolve(resp)
          }
        );
      });
    }

    obtenerRedesAcademicas = () => {
      return new Promise(resolve => {
        consulta(`api/v1.0/internacionalizacion/listarRedesAcademicas/`, null, null,
          (error, estado, resp) => {
            resolve(resp)
          }
        );
      });
    }


  actualizarEstado = (nombreEstado, valor) => {
    this.setState(prevState => ({
      [nombreEstado]: typeof valor === 'object' && !Array.isArray(valor)
        ? { ...prevState[nombreEstado], ...valor }
        : valor
    }));
  };

  // actualizarEstado = (nombreEstado, valor) => {
  //   this.setState(prevState => ({
  //     [nombreEstado]: typeof valor === 'object'
  //       ? { ...prevState[nombreEstado], ...valor }
  //       : valor
  //   }));
  // };


  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({ [name]: value });
  }

  onChangeFile = ({ target }, f) => {
    let { value, name } = target;
    this.setState({ [name]: value, info_complementaria_f: f });
  }

  onChangeParticipante = (event) => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      datosParticipante: {
        ...prevState.datosParticipante,
        [name]: value
      }
    }));
  }

  onChangeDate = (nombre, date) => {
    this.setState({ [nombre]: date });
  }

  onChangeFinanciaciones = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      nuevaFinanciacion: {
        ...prevState.nuevaFinanciacion,
        [name]: value,
      },
    }));
  };

  handleToggleFin = (index) => {
    this.setState(prevState => {
      const financiaciones = [...prevState.financiaciones];
      financiaciones[index].expandido = !financiaciones[index].expandido;
      return { financiaciones };
    });
  }

  handleToggle = (identificacion, id) => {
    const { participantesSelect } = this.state;
    const currentIndex = participantesSelect.findIndex(participante => participante.identificacion === identificacion);

    if (currentIndex === -1) this.setState(prevState => ({ participantesSelect: [...prevState.participantesSelect, { identificacion }] }));
    else this.setState(prevState => ({ participantesSelect: prevState.participantesSelect.filter(participante => !(participante.identificacion === identificacion)) }));
  };

  isParticipanteSelected(identificacion, id) {
    const { participantesSelect } = this.state;
    return participantesSelect.some(participante => participante.identificacion === identificacion);
  }

  handleSelectAllToggle = () => {
    const { participantes, selectAll } = this.state;
    const allParticipants = participantes.map(participante => ({ identificacion: participante.identificacion }));
    this.setState({ selectAll: !selectAll, participantesSelect: selectAll ? [] : allParticipants });
  };

  seleccionarInstitucionActividad = ({ id, institucion, pais_vinculante, ciudad_vinculante, codigo_convenio, actividades, tipoConvenio, fecha_vencimiento }) => {
    const { instituciones, errores } = this.state;
    this.setState({
      instituciones: instituciones.concat({ id, institucion, pais_vinculante, ciudad_vinculante, codigo_convenio, actividades, tipoConvenio, fecha_vencimiento }),
      errores: errores.length > 0 ? errores.filter(er => er.llave !== 'instituciones') : errores
    });
  }

  agregarFinanciacion = async () => {
    const { nuevaFinanciacion, financiaciones, es_financiado, dependencia, tipo_moneda } = this.state;
    const { actualizarMensaje } = this.props;

    let errores = await validateInputs([
      { value: es_financiado, name: 'es_financiado', err: { empty: true } },
    ]);

    if (es_financiado == '1') {
      if (nuevaFinanciacion.tipo_financiacion == '') errores.push({ llave: 'tipo_financiacion', 'mensaje': `Este campo es obligatorio` });
      if (nuevaFinanciacion.tipo_financiacion == TIPO_FIN_INSTITUCIONAL) {
        if (nuevaFinanciacion.dependencia == '') errores.push({ llave: dependencia, 'mensaje': `Este campo es obligatorio` });
      } else {
        if (nuevaFinanciacion.fuente_financiacion == '') errores.push({ llave: 'fuente_financiacion', 'mensaje': `Este campo es obligatorio` });
        if (nuevaFinanciacion.fuente_financiacion !== '') {
          if (nuevaFinanciacion.entidad == '') errores.push({ llave: 'entidad', 'mensaje': `Este campo es obligatorio` });
        }
      }

      if (nuevaFinanciacion.valor_cop == '') errores.push({ llave: 'valor_cop', 'mensaje': `Este campo es obligatorio` });
      if (nuevaFinanciacion.tipo_moneda == '') errores.push({ llave: 'tipo_moneda', 'mensaje': `Este campo es obligatorio` });
      if (nuevaFinanciacion.tipo_moneda != 'none' && tipo_moneda != '') {
        if (nuevaFinanciacion.valor_ext == '') errores.push({ llave: 'valor_ext', 'mensaje': `Este campo es obligatorio` });
      }
      if (nuevaFinanciacion.clasificacion_de_financiacion == '') errores.push({ llave: 'clasificacion_de_financiacion', 'mensaje': `Este campo es obligatorio` });
      if (nuevaFinanciacion.clasificacion_de_financiacion == CODIGO_TIPO_CONCEPTO_OTRO) {
        if (nuevaFinanciacion.otro_tipo_de_concepto == '') errores.push({ llave: 'otro_tipo_de_concepto', 'mensaje': `Este campo es obligatorio` });
      }

    }

    if (errores.length > 0) {
      this.setState({ errores });
      actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
      this.setState({ cargandoForm: false });
      return;
    }

    nuevaFinanciacion.es_financiado = es_financiado;

    // Agregar la nueva financiación al array de financiaciones
    this.setState({
      financiaciones: [...financiaciones, nuevaFinanciacion],
      nuevaFinanciacion: { // Reinicia el formulario después de agregar
        tipo_financiacion: '',
        dependencia: '',
        fuente_financiacion: '',
        entidad: '',
        valor_cop: '',
        tipo_moneda: '',
        valor_ext: '',
        clasificacion_de_financiacion: '',
        otro_tipo_de_concepto: '',
      },
      mostrarFormulario: false,
      errores: [],
    });
  };

  eliminarFinanciacion = (index) => {
    const { financiaciones } = this.state;
    const nuevasFinanciaciones = financiaciones.filter((_, i) => i !== index);
    this.setState({ financiaciones: nuevasFinanciaciones });
  }

  mostrarFormularioNuevaFinanciacion = (bool, type = null) => {
    if (type == 'cancelar') { 
      this.setState({ nuevaFinanciacion: { tipo_financiacion: '', dependencia: '', fuente_financiacion: '', entidad: '', valor_cop: '', tipo_moneda: '', valor_ext: '', clasificacion_de_financiacion: '', otro_tipo_de_concepto: '' }, mostrarFormulario: false });
    }
    this.setState({ mostrarFormulario: bool });
  };

  buscarDataFinanciacion = async (data) => {
    //console.log(data)
    let { tipos_financiaciones, fuentes_financiacion, dependencias } = this.state;
    const tipo_fin = data.tipo_financiacion ? tipos_financiaciones.find(({ id }) => id == data.tipo_financiacion) : null;
    const fuente_fin = data.fuente_financiacion ? fuentes_financiacion.find(({ id }) => id == data.fuente_financiacion) : null;
    const depen = data.dependencia ? dependencias.find(({ id }) => id == data.dependencia) : null;
    data = {
      tipo_financiacion: tipo_fin ? tipo_fin.nombre : 'No disponible',
      fuente_financiacion: fuente_fin ? fuente_fin.nombre : 'No disponible',
      dependencia: depen ? depen.nombre : 'No disponible',
    }
    return data;
  }

  renderButton = (accion, nombre) => {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={accion}
        style={{
          fontSize: '0.8em',
          borderRadius: '1.5em',
          padding: '0.6em 1.2em',
          minWidth: 'auto',
          minHeight: 'auto',
          color: 'white'
        }}
      >
        {nombre}
        {/* <AttachMoneyIcon style={{ fontSize: 'small' }} /> */}
      </Button>
      // <AddCircleOutlineIcon color='primary' fontSize='default' style={{ cursor: 'pointer',  }} onClick={accion} />

    )
  }

  quitarParticipante = () => {
    let { participantes, participante_quitar, info_inicial_participantes, financiacion_participantes, institucion_participantes } = this.state;
    let { actualizarMensaje } = this.props;

    // Filtrar participante a eliminar de la lista de participantes
    let participantesNew = participantes.filter(({ identificacion }) => identificacion !== participante_quitar.identificacion);

    // Filtrar participante a eliminar de info_inicial_participantes
    let infoInicialParticipantesNew = info_inicial_participantes.map(item => {
      const participantesFiltrados = item.participantes.filter(participante => participante !== participante_quitar.identificacion);
      // Si el participante a eliminar es el único registrado, eliminamos toda la entrada
      if (participantesFiltrados.length === 0) {
        return null; // No retornamos este item
      } else {
        return { ...item, participantes: participantesFiltrados };
      }
    }).filter(Boolean); // Filtramos los elementos nulos

    // Filtrar participante a eliminar de financiacion_participantes
    let financiacionParticipantesNew = financiacion_participantes.map(item => {
      const participantesFiltrados = item.participantes.filter(participante => participante !== participante_quitar.identificacion);
      // Si el participante a eliminar es el único registrado, eliminamos toda la entrada
      if (participantesFiltrados.length === 0) {
        return null; // No retornamos este item
      } else {
        return { ...item, participantes: participantesFiltrados };
      }
    }).filter(Boolean); // Filtramos los elementos nulos

    // Filtrar participante a eliminar de institucion_participantes
    let institucionParticipantesNew = institucion_participantes.map(item => {
      const participantesFiltrados = item.participantes.filter(participante => participante !== participante_quitar.identificacion);
      // Si el participante a eliminar es el único registrado, eliminamos toda la entrada
      if (participantesFiltrados.length === 0) {
        return null; // No retornamos este item
      } else {
        return { ...item, participantes: participantesFiltrados };
      }
    }).filter(Boolean); // Filtramos los elementos nulos


    // Actualizar estados
    this.setState({
      participantes: participantesNew,
      info_inicial_participantes: infoInicialParticipantesNew,
      financiacion_participantes: financiacionParticipantesNew,
      institucion_participantes: institucionParticipantesNew,
      modalDelParticipante: false,
      participante_quitar: 0,
      participantesSelect: [],
      cargando: false
    });

    // Mostrar mensaje de eliminación
    actualizarMensaje({ titulo: 'Participante Eliminado', tipo: 'danger', mostrar: true, tiempo: 6000 });
  }

  onChangeMulti = (selected, back, tipo) => {
    let resp = [];
    // let { backtiporesponsable } = this.state;
    selected.map((element) => {
      back.map((e) => {
        if (tipo == 'codigo') {
          if (element === e.codigo) return resp.push(e.nombre)
        } else {
          if (element === e.id) return resp.push(e.nombre)
        }
        return null;
      })
      return null;
    });
    return resp.join(", ")
  }

  guardarParticipanteNuevoInt = async () => {
    let { actualizarMensaje } = this.props;
    let { datosParticipante: { primer_nombre, primer_apellido, tipo_identificacion, identificacion, nacionalidad }, participantes, datosParticipante, tipos_identificacion } = this.state;

    // Validar campos obligatorios
    let errores = await validateInputs([
      { value: primer_nombre, name: 'primer_nombre', err: { empty: true } },
      { value: primer_apellido, name: 'primer_apellido', err: { empty: true } },
      { value: tipo_identificacion, name: 'tipo_identificacion', err: { empty: true } },
      { value: identificacion, name: 'identificacion', err: { empty: true } },
      { value: nacionalidad, name: 'nacionalidad', err: { empty: true } },
    ]);

    if (tipo_identificacion && identificacion && tipos_identificacion) {
      const tipoIdentificacionObj = tipos_identificacion.find(tipo => tipo.id === tipo_identificacion);
      
      if (tipoIdentificacionObj && tipoIdentificacionObj.valorc) {
        const longitudMinima = parseInt(tipoIdentificacionObj.valorc);
        
        if (!isNaN(longitudMinima) && identificacion.length < longitudMinima) {
          
          this.setState({ errores });
          actualizarMensaje({ 
            titulo: `El ${tipoIdentificacionObj.nombre} debe tener mínimo ${longitudMinima} caracteres`, 
            tipo: 'warning', 
            mostrar: true, 
            tiempo: 6000 
          });
          return;
        }
      }
    }

    // Si hay errores en los campos obligatorios, mostrar mensaje y salir de la función
    if (errores.length > 0) {
      this.setState({ errores });
      actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
      return;
    }

    // Validar si la identificación ya está registrada
    let participanteExistente = participantes.find(participante => participante.identificacion === identificacion);
    if (participanteExistente) {
      actualizarMensaje({ titulo: 'Ya existe un participante registrado con esta identificación', tipo: 'info', mostrar: true, tiempo: 6000 });
      return; // Salir de la función si la identificación ya está registrada
    }

    // Si no hay errores y la identificación no está registrada, guardar el participante
    this.setState({ cargando: true });
    participantes.push(datosParticipante);
    this.setState({ participantes, modalAddParticipante: false, errores, datosParticipante: { primer_nombre: '', segundo_nombre: '', primer_apellido: '', segundo_apellido: '', tipo_identificacion: '', identificacion: '', nacionalidad: '', celular: '', correo_personal: '', correo: '', indicativo_celular: '' }, cargando: false, modalAddParticipantExt: false });
  }

  guardarParticipanteEmma = async (data) => {
    let { actualizarMensaje } = this.props;
    let { participantes } = this.state;
    this.setState({ cargando: true });
    //console.log("EMMA")
    console.log(data)
    let datos = {
      id: data.id,
      primer_nombre: data.primer_nombre,
      segundo_nombre: data.segundo_nombre ?? '',
      primer_apellido: data.primer_apellido,
      segundo_apellido: data.segundo_apellido ?? '',
      tipo_identificacion: data.tipo_identificacion ?? '',
      identificacion: data.identificacion ?? '',
      correo: data.correo ?? '',
      correo_personal: data.correo_personal ?? '',
      indicativo_celular: data.indicativo_celular ?? '',
      celular: data.celular ?? '',
      nacionalidad: data.nacionalidad ?? '',
    }
    // this.setState({ cargando: true });
    participantes.push(datos);
    actualizarMensaje({ titulo: 'Participante agregado', tipo: 'success', mostrar: true, tiempo: 6000 });
    this.setState({ participantes, cargando: false });
  }

  // guardarInfoPrincipalParticipantes = async () => {
  //   let { actualizarMensaje } = this.props;
  //   const { participantesSelect, tipo_movilidad, tipo_modalidad, plataforma, otra_plataforma, info_inicial_participantes } = this.state;
  //   let errores = await validateInputs([
  //     { value: tipo_movilidad, name: 'tipo_movilidad', err: { empty: true } },
  //     { value: tipo_modalidad, name: 'tipo_modalidad', err: { empty: true } },
  //     // { value: plataforma, name: 'plataforma', err: { empty: true } },
  //   ]);
  //   if (MODALIDADES_VIRTUALES.includes(tipo_modalidad) && plataforma === '') errores.push({ name: 'plataforma', err: { empty: true } });
  //   if (plataforma === 'otra' && otra_plataforma === '') errores.push({ name: 'otra_plataforma', err: { empty: true } });
  //   console.log(errores)

  //   if (errores.length === 0) {
  //     this.setState({ cargandoForm: true });
  //     let copia_info = [...info_inicial_participantes];
  //     let participantes = [];
  //     participantesSelect.forEach((participante) => {
  //       let { identificacion } = participante;
  //       participantes.push(identificacion);
  //     });
  //     let data = { participantes: participantes, tipo_movilidad: tipo_movilidad, tipo_modalidad: tipo_modalidad, plataforma: plataforma, otra_plataforma: otra_plataforma };
  //     copia_info.push(data);
  //     this.setState({ info_inicial_participantes: copia_info, modalAddInfoBasica: false });
  //   } else {
  //     this.setState({ errores });
  //     actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
  //   }
  //   this.setState({ cargandoForm: false });
  // }

  guardarInfoPrincipalParticipantes = async () => {
    const { actualizarMensaje } = this.props;
    const { participantesSelect, tipo_movilidad, tipo_modalidad, plataforma, otra_plataforma, info_inicial_participantes } = this.state;

    // Validar campos obligatorios
    const errores = [];
    if (!tipo_movilidad) errores.push({ llave: 'tipo_movilidad', mensaje: 'Este campo es obligatorio' });
    if (!tipo_modalidad) errores.push({ llave: 'tipo_modalidad', mensaje: 'Este campo es obligatorio' });

    // Verificar plataforma en caso de modalidades virtuales
    if (MODALIDADES_VIRTUALES.includes(tipo_modalidad)) {
      if (!plataforma) errores.push({ llave: 'plataforma', mensaje: 'Este campo es obligatorio' });
      if (plataforma === OTRA_PLATAFORMA && !otra_plataforma) {
        errores.push({ llave: 'otra_plataforma', mensaje: 'Este campo es obligatorio' });
      }
    }

    // Mostrar errores si los hay
    if (errores.length > 0) {
      this.setState({ errores });
      actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
      this.setState({ cargandoForm: false });
      return;
    }

    // Verificar duplicados
    const duplicados = participantesSelect.some(participante => info_inicial_participantes.some(item => item.participantes.includes(participante.identificacion)));

    // Mostrar mensaje si hay duplicados
    if (duplicados) {
      actualizarMensaje({ titulo: 'Algunos de los participantes seleccionados ya tienen esta información registrada.', tipo: 'info', mostrar: true, tiempo: 6000 });
      this.setState({ cargandoForm: false });
      return;
    }

    // Actualizar info_inicial_participantes
    const participantes = participantesSelect.map(participante => participante.identificacion);
    const data = { participantes, tipo_movilidad, tipo_modalidad, plataforma, otra_plataforma };
    this.setState(prevState => ({
      info_inicial_participantes: [...prevState.info_inicial_participantes, data],
      modalAddInfoBasica: false,
      cargandoForm: false
    }));
    this.resetForm('info_basica')
  };


  guardarFinanciacionParticipantes = async () => {
    const { participantesSelect, es_financiado, tipo_financiacion, dependencia, fuente_financiacion, entidad, valor_cop, tipo_moneda, valor_ext, clasificacion_de_financiacion, otro_tipo_de_concepto, comprobante_financiacion, financiacion_participantes, financiaciones, nuevaFinanciacion } = this.state;
    const { actualizarMensaje } = this.props;

    // Verificar duplicados
    const duplicados = participantesSelect.some(participante => financiacion_participantes.some(item => item.participantes.includes(participante.identificacion)));

    // Mostrar mensaje si hay duplicados
    if (duplicados) {
      actualizarMensaje({ titulo: 'Algunos de los participantes seleccionados ya tienen esta información registrada.', tipo: 'info', mostrar: true, tiempo: 6000 });
      this.setState({ cargandoForm: false });
      return;
    }

    const participantes = participantesSelect.map(participante => participante.identificacion);
    let data = {}
    if (es_financiado == '1') {
      data = { participantes, financiaciones: financiaciones };
    } else {
      nuevaFinanciacion.es_financiado = es_financiado;
      let financiaciones = [nuevaFinanciacion];
      data = { participantes, financiaciones };
    }
    this.setState(prevState => ({
      financiacion_participantes: [...prevState.financiacion_participantes, data],
      modalAddFinanciacion: false,
      cargandoForm: false
    }));
    this.resetForm('financiacion')
  }

  guardarInstitucionParticipante = async () => {
    let { actualizarMensaje } = this.props;
    let { institucion_participante, tipo_participante, nivel_participante, programa_participante, dpto_participante, facultad_participante, dependencia_participante, institucion_participantes, participantesSelect } = this.state;

    let errores = await validateInputs([]);

    if (institucion_participante.institucion == '') errores.push({ llave: 'institucion_participante', 'mensaje': `Este campo es obligatorio` });
    if (tipo_participante == null) errores.push({ llave: 'tipo_participante', 'mensaje': `Este campo es obligatorio` });

    if (tipo_participante == TIPO_PARTICIPANTE_ESTU) {
      if (facultad_participante == '') errores.push({ llave: 'facultad_participante', 'mensaje': `Este campo es obligatorio` });
      if (nivel_participante == '') errores.push({ llave: 'nivel_participante', 'mensaje': `Este campo es obligatorio` });
      if (programa_participante == '') errores.push({ llave: 'programa_participante', 'mensaje': `Este campo es obligatorio` });
    } else if (tipo_participante == TIPO_PARTICIPANTE_DOC) {
      if (dpto_participante == '') errores.push({ llave: 'dpto_participante', 'mensaje': `Este campo es obligatorio` });
      if (programa_participante == '') errores.push({ llave: 'programa_participante', 'mensaje': `Este campo es obligatorio` });
    } else if (tipo_participante == TIPO_PARTICIPANTE_ADMIN) {
      if (dpto_participante == '') errores.push({ llave: 'dpto_participante', 'mensaje': `Este campo es obligatorio` });
      if (programa_participante == '') errores.push({ llave: 'programa_participante', 'mensaje': `Este campo es obligatorio` });
    }
    //console.log(errores)

    if (errores.length > 0) {
      this.setState({ errores });
      actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
      return;
    }

    // VERIFICAR SI HAY DUPLICADOS
    const duplicados = participantesSelect.some(participante => institucion_participantes.some(item => item.participantes.includes(participante.identificacion)));

    // Mostrar mensaje si hay duplicados
    if (duplicados) {
      actualizarMensaje({ titulo: 'Algunos de los participantes seleccionados ya tienen esta información registrada.', tipo: 'info', mostrar: true, tiempo: 6000 });
      this.setState({ cargandoForm: false });
      return;
    }

    // Actualizar institucion_participantes
    const participantes = participantesSelect.map(participante => participante.identificacion);

    let data = { participantes, institucion: institucion_participante.id, tipo_participante, nivel_participante, programa_participante, facultad_participante, dpto_participante, programa_participante };

    // data = { ...data, nivel_participante, programa_participante, facultad_participante, dpto_participante, programa_participante };
    // if (tipo_participante == TIPO_PARTICIPANTE_ESTU) {
    // } else if (tipo_participante == TIPO_PARTICIPANTE_DOC || tipo_participante == TIPO_PARTICIPANTE_ADMIN) {
    //   data = { ...data, dpto_participante, programa_participante };
    // }

    this.setState(prevState => ({
      institucion_participantes: [...prevState.institucion_participantes, data],
      modalAddInstitucion: false,
      cargandoForm: false
    }));
    this.resetForm('institucion')
  }

  guardarActividadParticipantes = () => {
    const { participantesSelect, tipo_actividad, otro_tipo_actividad, subtipo_actividad, otro_subtipo_actividad, fecha_inicio, fecha_fin, responsable_actividad, dpto_responsable, facultad_responsable, administrativos_responsable, actividad_participantes, info_complementaria, titulo_tema, descripcion_actividad, resultados_descripcion } = this.state;
    let copia_info = [...actividad_participantes];
    let participantes = [];
    participantesSelect.forEach((participante) => {
      let { identificacion } = participante;
      participantes.push(identificacion);
    });
    let data = { participantes: participantes, tipo_actividad: tipo_actividad, otro_tipo_actividad: otro_tipo_actividad, subtipo_actividad: subtipo_actividad, otro_subtipo_actividad: otro_subtipo_actividad, fecha_inicio: fecha_inicio ? moment(fecha_inicio).format("YYYY-MM-DD") : "", fecha_fin: fecha_fin ? moment(fecha_fin).format("YYYY-MM-DD") : "", responsable_actividad: responsable_actividad, dpto_responsable: dpto_responsable, facultad_responsable: facultad_responsable, administrativos_responsable: administrativos_responsable, info_complementaria: info_complementaria, titulo_tema: titulo_tema, descripcion_actividad: descripcion_actividad, resultados_descripcion: resultados_descripcion };
    copia_info.push(data);
    this.setState({ actividad_participantes: copia_info, modalAddActividad: false });
  }

  agregarInstitucionParticipante = (id, institucion, pais_vinculante, ciudad_vinculante, actividades, tipoConvenio) => {
    let { errores } = this.state;
    this.setState({ institucion_participante: { id: id, institucion, pais_vinculante: pais_vinculante ?? '', ciudad_vinculante: ciudad_vinculante ?? '', actividades: actividades ?? [], tipoConvenio: tipoConvenio ?? [] }, errores: errores.length > 0 ? errores.filter(er => er.llave !== 'institucion_participante') : errores });
  }

  resetForm = (tipo) => {
    if (tipo === 'participante') {
      this.setState({ datosParticipante: { primer_nombre: '', segundo_nombre: '', primer_apellido: '', segundo_apellido: '', tipo_identificacion: '', identificacion: '', nacionalidad: '', celular: '', correo_personal: '', correo: '', indicativo_celular: '' }, errores: [] });
    } else if (tipo === 'info_basica') {
      this.setState({ tipo_movilidad: '', tipo_modalidad: '', plataforma: '', otra_plataforma: '' });
    } else if (tipo === 'financiacion') {
      this.setState({ financiaciones: [], nuevaFinanciacion: { tipo_financiacion: '', dependencia: '', fuente_financiacion: '', entidad: '', valor_cop: '', tipo_moneda: '', valor_ext: '', clasificacion_de_financiacion: '', otro_tipo_de_concepto: '' }, es_financiado: '', tipo_financiacion: '', dependencia: '', fuente_financiacion: '', entidad: '', valor_cop: '', tipo_moneda: '', valor_ext: '', clasificacion_de_financiacion: '', otro_tipo_de_concepto: '', comprobante_financiacion: '', error: false, participante_tipo: null, tipos_participantes: [], tipo_participante: null, mostrandoFormulario: false });

    } else if (tipo === 'institucion') {
      this.setState({ institucion_participante: { id: 0, institucion: '', pais_vinculante: '', ciudad_vinculante: '' }, tipo_participante: '', nivel_participante: '', programa_participante: '', dpto_participante: '', facultad_participante: '', dependencia_participante: '' });
    }
    // else if (tipo === 'actividad') {
    //   this.setState({ tipo_actividad: '', otro_tipo_actividad: '', subtipo_actividad: '', otro_subtipo_actividad: '', fecha_inicio: null, fecha_fin: null, responsable_actividad: [], dpto_responsable: [], facultad_responsable: [], administrativos_responsable: [], titulo_tema: '', descripcion_actividad: '', resultados_descripcion: '', info_complementaria: '' });
    // }

  }

  submit = async (archivos) => {
    let { actualizarMensaje } = this.props;
    if (archivos.length > 0) {
      // this.setState({ cargandoForm: true });
      this.submitForm(archivos);
    } else actualizarMensaje({ titulo: 'Debe adjuntar por lo menos una evidencia.', tipo: 'info', mostrar: true, tiempo: 6000 });
  }

  submitForm = async (archivos) => {
    let { actualizarMensaje, guardarRegistro } = this.props;
    let { participantes, info_inicial_participantes, financiacion_participantes, actividad_participantes, institucion_participantes, info_complementaria, info_complementaria_f, departamento_docente, programa_docente, solicitudSelect, id_solicitud_borrador, periodoSeleccionado } = this.state;
    this.setState({ cargando: true, enviando: true, tit_cargando: 'Guardando registro...' });
    let data = new FormData();
    if (info_complementaria) data.append('info_complementaria', info_complementaria_f); 
    // data.append({ archivo: new File([info_complementaria], ''), codigo: 1250 });
    archivos.map(({ archivo, codigo }, index) => {
      data.append(`archivo${index}`, archivo);
      data.append(`codigo${index}`, codigo);
    })
    data.append('total_evidencias', archivos.length);
    data.append('participantes', JSON.stringify(participantes));
    data.append('info_inicial_participantes', JSON.stringify(info_inicial_participantes));
    data.append('actividad_participantes', JSON.stringify(actividad_participantes));
    data.append('financiacion_participantes', JSON.stringify(financiacion_participantes));
    data.append('institucion_participantes', JSON.stringify(institucion_participantes));
    data.append('departamento_docente', departamento_docente)
    data.append('programa_docente', programa_docente)
    data.append('solicitud_seleccionada', solicitudSelect.id ? solicitudSelect.id : id_solicitud_borrador)
    if (periodoSeleccionado) data.append('periodoSeleccionado', periodoSeleccionado);

    const reset = () => {
      this.setState({ cargando: false, modalAddRegistro: false, 
        enviando: false, tipo_actividad: '', subtipo_actividad: '', 
        otro_tipo_actividad: '', otro_subtipo_actividad: '', 
        fecha_inicio: null, fecha_fin: null, responsable_actividad: [], 
        dpto_responsable: [], facultad_responsable: [], 
        administrativos_responsable: [], titulo_tema: '', 
        descripcion_actividad: '', resultados_descripcion: '', 
        info_complementaria: '', info_complementaria_f: null, 
        participantes: [], info_inicial_participantes: [], 
        financiacion_participantes: [], institucion_participantes: [], 
        actividad_participantes: [], instituciones: [], tipo_movilidad: '', 
        tipo_modalidad: '', plataforma: '', otra_plataforma: '', 
        participantesSelect: [], es_financiado: '', tipo_financiacion: '', 
        dependencia: '', fuente_financiacion: '', entidad: '', 
        valor_cop: '', tipo_moneda: '', valor_ext: '', clasificacion_de_financiacion: '', 
        otro_tipo_de_concepto: '', comprobante_financiacion: '', 
        participante_tipo: null, tipos_participantes: [], 
        tipo_participante: null, errores: [], 
        institucion_participante: { id: 0, institucion: '', pais_vinculante: '', ciudad_vinculante: '' }, 
        facultad_participante: '', nivel_participante: '', programa_participante: '', 
        dpto_participante: '', dependencia_participante: '', actividad_participante: '', 
        activeStep: 0, mostrarForm: false, departamento_docente: '', programa_docente: '', periodoSeleccionado: '', redAcademicaSelect: null });
    }

    await guardarRegistro(data, reset);
  }


  enviarParticipantesMasivo = async (archivo) => {
    let { actualizarMensaje } = this.props;
    if (archivo.length === 0) return true;
    this.setState({ modalAddParticipanteMasivo: false, cargando: true })
    let data = await crear_form_data({ archivo });
    formulario(`api/v1.0/internacionalizacion/obtener_datosParticipantesMasivo`, data, 'post', (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo;
          this.cargarParticipante(resp.participantes_agregados)
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
          this.setState({ cargandoForm: false, cargando: false })
        }
      }
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 60000 });
      this.setState({ cargando: false });
    });
  }

  // ☢️ CONSTRUCCION 
  cargarParticipante = async (participantes_masivos) => {
    let { actualizarMensaje } = this.props;
    let { participantes } = this.state;
    this.setState({ cargando: true });
    let participantesNuevos = [];
    participantes_masivos.map((participante, index) => {
      let { primer_nombre, segundo_nombre, primer_apellido, segundo_apellido, tipo_identificacion, identificacion, correo, correo_personal, indicativo_celular, celular, nacionalidad } = participante;
      //console.log(participante)
      let data = { id: index, primer_nombre, segundo_nombre: segundo_nombre ?? '', primer_apellido, segundo_apellido: segundo_apellido ?? '', tipo_identificacion, identificacion, correo: correo ?? '', correo_personal: correo_personal ?? '', indicativo_celular: indicativo_celular ?? '', celular: celular ?? '', nacionalidad: nacionalidad ?? '' };
      participantesNuevos.push(data);
    });
    participantes = participantes.concat(participantesNuevos);
    this.setState({ participantes, cargando: false });

  }

  pintarParticipantes() {
    let { participantesSelect, participantes, info_inicial_participantes, institucion_participantes, financiacion_participantes, selectAll, tipos_movilidades_all, tipos_identificacion, cargando, } = this.state;
    const acciones = (data, tipo) => {
      if (tipo === 'participante') {
        const onClickDetalle = data => {
          let tipo_identificacion = tipos_identificacion.find(tipo => tipo.id === (typeof data.tipo_identificacion === 'object' ? data.tipo_identificacion.id : data.tipo_identificacion));
          //console.log(tipo_identificacion)
          let participanteDetalle = { ...data }
          participanteDetalle.tipo_identificacion = { nombre: tipo_identificacion.nombre, id: tipo_identificacion.id };
          // data.tipo_identificacion = { nombre: tipo_identificacion.nombre, id: tipo_identificacion.id};
          this.setState({ modalDetParticipante: true, participanteDetalle: participanteDetalle });
        }
        const onClickQuitar = data => this.setState({ modalDelParticipante: true, participante_quitar: data });
        return (
          <>
            <Tooltip title="Seleccionar">
              <Checkbox edge="start" onChange={() => this.handleToggle(data.identificacion, data.id)} checked={this.isParticipanteSelected(data.identificacion, data.id)} style={{ color: '#2196f3' }} />
            </Tooltip>
            <BtnDetalle callback={() => onClickDetalle(data)} texto='Detalle' />
            {/* <BtnEditar callback={() => onClickDetalle(data)} texto='Editar' color='#328e32' /> */}
            <BtnCancelar callback={() => onClickQuitar(data)} texto='Quitar' color='#cc0000' />
          </>
        );
      } else {
        return (
          <Tooltip title="Seleccionar todo">
            <Checkbox onChange={() => this.handleSelectAllToggle()} checked={this.state.selectAll} style={{ color: '#2196f3' }} />
          </Tooltip>
        );
      }
    };

    const renderIconos = (data, tipo) => {
      const participantesData = { 'info_basica': info_inicial_participantes, 'financiacion': financiacion_participantes, 'institucion': institucion_participantes };
      const info_inicial = participantesData[tipo].find(participante => participante.participantes.includes(data.identificacion));
      return <CheckBoxIcon color={info_inicial ? 'primary' : 'disabled'} />;
    };

    const renderMovilidad = (data) => {
      const info_inicial = info_inicial_participantes.find(participante => participante.participantes.includes(data.identificacion));
      if (info_inicial) {
        const tipoMovilidadId = info_inicial.tipo_movilidad;
        const tipoMovilidadEncontrado = tipos_movilidades_all.find(tipo => tipo.id === tipoMovilidadId);
        return tipoMovilidadEncontrado ? tipoMovilidadEncontrado.nombre : '';
      } else return 'No registra'
    };

    return (
      <>
        <Grid container spacing={2} style={{}}>
          <Grid item xs={12}>
            {cargando && <TareasTerminadas mensaje={'Cargando..'} marginTop='1%' imagen={emma_s1} widthImg="9%" style={{ minWidth: '60%' }} />}
            {(participantes.length > 0 && !cargando) ?
              <div style={{ margin: '0 0 3% 0 ' }}>
                <div style={{ display: 'flex', justifyContent: 'end', margin: '0% 0 1% 0' }}>
                  <Button variant="contained" color="primary" style={{ borderRadius: '20px', color: 'white' }} disabled={participantesSelect.length === 0} onClick={() => participantesSelect.length > 0 && this.setState({ modalContenedor: true })} >
                    <AddIcon />
                  </Button>
                </div>

                <Paper sx={{ width: '100%', overflow: 'hidden', marginBottom: '5%', marginTop: '3%' }}>
                  <TableContainer sx={{ maxWidth: '100%' }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow key={0} style={{ padding: '5px', justifyContent: 'space-between' }} >
                          <TableCell style={{ minWidth: '2rem', maxWidth: '9.5rem', padding: '3px' }} >{acciones(participantes, 'todo')}</TableCell>
                          <TableCell style={{ minWidth: '2rem', maxWidth: '9rem', padding: '3px', textAlign: 'center' }} >NOMBRE</TableCell>
                          <TableCell style={{ minWidth: '2rem', maxWidth: '8rem', padding: '3px', textAlign: 'center' }} >IDENTIFICACIÓN</TableCell>
                          <TableCell style={{ minWidth: '2rem', maxWidth: '8rem', padding: '3px', textAlign: 'center' }} >TIPO MOVILIDAD</TableCell>
                          <TableCell style={{ minWidth: '2rem', maxWidth: '4rem', padding: '3px', textAlign: 'center' }} >INFORMACIÓN BÁSICA</TableCell>
                          <TableCell style={{ minWidth: '2rem', maxWidth: '5rem', padding: '3px', textAlign: 'center' }} >FINANCIACIÓN</TableCell>
                          <TableCell style={{ minWidth: '2rem', maxWidth: '4rem', padding: '3px', textAlign: 'center' }} >INSTITUCIÓN</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {participantes.map((participante, i) => {
                          let nombre_completo = `${participante.primer_nombre ?? ''} ${participante.segundo_nombre ?? ''} ${participante.primer_apellido ?? ''} ${participante.segundo_apellido ?? ''}`;
                          return (
                            <TableRow key={i} style={{ padding: '5px', justifyContent: 'space-between' }}>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '9.5rem' }} >{acciones(participante, 'participante')}</TableCell>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '9rem', padding: '3px', textAlign: 'center' }}>{nombre_completo.toUpperCase()}</TableCell>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '8rem', padding: '3px', textAlign: 'center' }} >{participante.identificacion}</TableCell>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '8rem', padding: '3px', textAlign: 'center' }} >{renderMovilidad(participante)}</TableCell>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '4rem', textAlign: 'center' }} >{renderIconos(participante, 'info_basica')}</TableCell>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '5rem', textAlign: 'center' }} >{renderIconos(participante, 'financiacion')}</TableCell>
                              <TableCell style={{ minWidth: '2rem', maxWidth: '4rem', textAlign: 'center' }} >{renderIconos(participante, 'institucion')}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </div>
              :
              <TareasTerminadas mensaje={<React.Fragment>  No hay participantes registrados. <br />  Haga clic en el botón para añadir un nuevo participante</React.Fragment>} marginTop='1%' imagen={emma_s1} widthImg="9%" style={{ minWidth: '60%' }} />
            }
          </Grid>
        </Grid >
        <div style={{ textAlign: 'center', position: 'sticky', bottom: '0', zIndex: '1000', backgroundColor: 'white', display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" color="primary" style={{ borderRadius: '20px', color: 'white', marginRight: '8px' }} onClick={() => this.setState({ modalAddParticipante: true })}>Añadir participante<PersonAddIcon style={{ marginLeft: '0.6rem' }} /></Button>
          <Button variant="contained" color="primary" style={{ borderRadius: '20px', color: 'white' }} onClick={() => this.setState({ modalAddParticipanteMasivo: true })}>Participante Masivo <PublishIcon style={{ marginLeft: '0.6rem' }} /></Button>
        </div>
      </>
    )
  }

  renderEvidencias = () => {
    // let { certificados_participantes, enlace_grabacion, modalidad_escogida, evidenciasAdjuntos } = this.state;
    let { evidencias, cargandoForm } = this.state;
    const trasnformarDataAdj = (data) => {
      let r = [];
      data.map(({ secundario }) => r.push({ nombre: secundario.nombre, codigo: secundario.id, archivo: secundario.archivo, formatos: '.pdf,.xls,.xlsx,.jpg,.jpeg,.png' }))
      return r;
    }
    const acciones = (data, callback) => {
      const onClickCargar = data => callback(data);
      let descargar = data.archivo && <BtnDescargar callback={() => window.open(`${data.archivo}`, '_blank')} color='#01579b' />
      let cargar = <BtnCargar callback={() => onClickCargar(data)} color='#00bfa5' />
      return <div>{descargar} {cargar}</div>;
    }
    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper elevation={0} square>
              <List component='nav' arial-label='main'>
                {cargandoForm && <TareasTerminadas mensaje={'Cargando evidencias..'} marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />}
                {evidencias && evidencias.length > 0 && !cargandoForm &&
                  <EnviarMultiplesArchivos
                    acciones={acciones}
                    enModal={false}
                    enviarArchivos={(archivos) => this.submit(archivos)}
                    limite={1}
                    mostrarMensaje={false}
                    enLista={true}
                    lista={trasnformarDataAdj(evidencias)}
                    formatos={true}
                  />}
              </List>
            </Paper>
          </Grid>
          {/* {
            CODIGOS_MODALIDADES_VIRTUALES.includes(modalidad_escogida.codigo) &&
              <Grid item xs = { 6 }>
                <TextField
                  value = { enlace_grabacion }
                  id = 'enlace_grabacion'
                  name = 'enlace_grabacion'
                  label = 'Enlace de grabación'
                  fullWidth
                  onChange = { this.onChange }
                />
              </Grid>
          }
          <Grid item xs = { CODIGOS_MODALIDADES_VIRTUALES.includes(modalidad_escogida.codigo) ? 6 : 12 }>
            <TextField
              className = 'oculto'
              ref = { this.fileInput }
              type = "file"
              id = "certificados_participantes"
              name = "certificados_participantes"
              label = 'Certificados de participantes'
              fullWidth
              autoComplete = "billing address-line1"
              onChange = { this.onChange }
            />
            <Grid item xs = { 12 }>
              <InputFile label = 'Certificados de participantes' id = 'certificados_participantes' required = { false } value = { certificados_participantes }/>
            </Grid>
          </Grid> */}
        </Grid>
      </React.Fragment>
    )
  }

  configStepContent = () => {
    let { activeStep, mostrarForm } = this.state;
    let { instructivo } = this.props
    return (
      <>
        {activeStep === 0 && <AgregarActividad state={this.state} actions={this} instructivo={instructivo} />}
        {activeStep === 1 && this.pintarParticipantes()}
        {activeStep === 2 && this.renderEvidencias()}
      </>
    );
  }

  handleStep = async (step) => {
    let { activeStep, departamento_docente, 
      programa_docente, tipo_actividad, 
      instituciones, fecha_inicio, fecha_fin, 
      responsable_actividad, administrativos_responsable, 
      titulo_tema, descripcion_actividad, 
      resultados_descripcion, dpto_responsable, 
      facultad_responsable, participantes, 
      info_inicial_participantes, financiacion_participantes, 
      institucion_participantes, otro_subtipo_actividad, 
      otro_tipo_actividad, subtipo_actividad, 
      isBorrador, periodoSeleccionado, pertenece_red_academica, redAcademicaSelect } = this.state;
    let { actualizarMensaje } = this.props;
    let errores = [];
    switch (activeStep) {
      case 0:
        errores = await validateInputs([
          { value: departamento_docente, name: 'departamento_docente', err: { empty: true } },
          { value: programa_docente, name: 'programa_docente', err: { empty: true } },
          { value: tipo_actividad, name: 'tipo_actividad', err: { empty: true } },
          { value: instituciones, name: 'instituciones', err: { empty: true } },
          { value: fecha_inicio, name: 'fecha_inicio', err: { not_null: true } },
          { value: fecha_fin, name: 'fecha_fin', err: { not_null: true } },
          { value: responsable_actividad, name: 'responsable_actividad', err: { empty: true } },
          { value: titulo_tema, name: 'titulo_tema', err: { empty: true } },
          { value: descripcion_actividad, name: 'descripcion_actividad', err: { empty: true } },
          { value: resultados_descripcion, name: 'resultados_descripcion', err: { empty: true } },
        ])
        if (responsable_actividad.includes('tipo_resp_admin')) {
          if (administrativos_responsable.length === 0) errores.push({ llave: 'administrativos_responsable', 'mensaje': `Seleccione al menos una unidad administrativa` });
        }
        if (responsable_actividad.includes('tipo_resp_dpto')) {
          if (dpto_responsable.length === 0) errores.push({ llave: 'dpto_responsable', 'mensaje': `Seleccione al menos un departamento` });
        }
        if (responsable_actividad.includes('tipo_resp_facul')) {
          if (facultad_responsable.length === 0) errores.push({ llave: 'facultad_responsable', 'mensaje': `Seleccione al menos una facultad` });
        }
        if (!periodoSeleccionado) {
          errores.push({ llave: 'periodoSeleccionado', 'mensaje': `Seleccione un periodo.` });
        }
        
        if (pertenece_red_academica === '1' && !redAcademicaSelect) {
          errores.push({ llave: 'redAcademicaSelect', 'mensaje': `Debe seleccionar una red académica.` });
        }

        if (fecha_inicio && fecha_fin) {
          let fechaInicio = new Date(fecha_inicio);
          let fechaFin = new Date(fecha_fin);
          if (fechaInicio > fechaFin) {
            errores.push({ llave: 'fecha_inicio', mensaje: 'Error en las fechas' });
            errores.push({ llave: 'fecha_fin', mensaje: 'Error en las fechas' });
            actualizarMensaje({ titulo: 'La fecha de inicio no puede ser posterior a la fecha final.', tipo: 'info', mostrar: true, tiempo: 6000 });
          }
        }
        // FALTAN MAS POR AGG
        // otro_subtipo_actividad
        // otro_tipo_actividad
        if (errores.length > 0) {
          this.setState({ errores });
          actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
        } else {
          let actividad = [
            { tipo_actividad: tipo_actividad, otro_tipo_actividad: otro_tipo_actividad, subtipo_actividad: subtipo_actividad, otro_subtipo_actividad: otro_subtipo_actividad, fecha_inicio: fecha_inicio ? moment(fecha_inicio).format("YYYY-MM-DD") : "", fecha_fin: fecha_fin ? moment(fecha_fin).format("YYYY-MM-DD") : "", responsable_actividad: responsable_actividad, dpto_responsable: dpto_responsable, facultad_responsable: facultad_responsable, administrativos_responsable: administrativos_responsable, titulo_tema: titulo_tema, descripcion_actividad: descripcion_actividad, resultados_descripcion: resultados_descripcion, instituciones: instituciones }
          ]
          this.setState({ actividad_participantes: actividad });
        }
        break;
      case 1:
        if (participantes.length === 0) {
          errores.push({ llave: 'participantes', 'mensaje': `Debes añadir al menos un participante.` });
          actualizarMensaje({ titulo: 'Debes añadir al menos un participante.', tipo: 'info', mostrar: true, tiempo: 6000 });
        } else {
          // Crear un conjunto que almacene todas las identificaciones únicas de participantes en cada categoría
          const participantesInfoInicial = new Set(info_inicial_participantes.flatMap(item => item.participantes));
          const participantesFinanciacion = new Set(financiacion_participantes.flatMap(item => item.participantes));
          const participantesInstitucion = new Set(institucion_participantes.flatMap(item => item.participantes));

          // Obtener identificaciones únicas de participantes registrados
          const participantesRegistrados = new Set(participantes.map(participante => participante.identificacion));

          // Verificar si todos los participantes registrados están presentes en todas las categorías
          const todosRegistrados = [...participantesRegistrados].every(participante =>
            participantesInfoInicial.has(participante) && participantesFinanciacion.has(participante) && participantesInstitucion.has(participante)
          );

          if (!todosRegistrados) {
            errores.push({ llave: 'participantes', 'mensaje': `Falta información por registrar.` });
            actualizarMensaje({ titulo: 'Falta información por registrar.', tipo: 'info', mostrar: true, tiempo: 6000 });
          }
        }
        break;
      case 2:
        errores = this.validarFinanciacion();
        break;
      default:
        break;
    }
    this.setState({ errores });
    if (errores.length === 0) {
      if (activeStep == 0) {
        if (!isBorrador) {
          this.setState({ cargando: true, tit_cargando: 'Guardando borrador...' });
          const ok = await this.onSubmitActividBorrador();
          this.setState({ cargando: false });
          // Al crear el borrador se marca isBorrador=true para que al volver a este paso
          // y avanzar de nuevo NO se cree un borrador duplicado.
          if (ok) this.setState({ activeStep: activeStep + 1, isBorrador: true });
        }
      };
      if (activeStep == 1 || isBorrador) this.setState({ activeStep: activeStep + 1 });
    }
    // this.setState({ activeStep: activeStep + 1 });
  }

  obtenerBorradorActividad = async () => {
    let { actualizarMensaje } = this.props;
    let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
    this.setState({ cargando: true, tit_cargando: 'Cargando borradores...' });
    try {
      consulta(
        'api/v1.0/internacionalizacion/registro/obtenerActividadBorrador',
        null, 
        'GET', 
        (error, estado, resp) => {
          if (error) {
            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
          } else {
            if (estado === 200) {
              if (resp.borradores.length <= 0 && resp.registro_solicitud.length <= 0) {
                this.actualizarEstado('mostrarForm', true);
                this.setState({ cargando: false });
              } else {
                this.setState({ modalSeguirBorrador: true, isBorrador: true, borradorActividad: resp, cargando: false, tit_cargando: '' });
              }
            } else {
              actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
              this.setState({ cargando: false, tit_cargando: '' });
            }
          }
        }
      );
    } catch (error) {
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
      this.setState({ cargando: false });
    }
  }

  eliminarBorrador = (id) => {
    let { actualizarMensaje } = this.props;
    // El cargando se muestra DENTRO del modal de borradores (que está por encima)
    this.setState({ modalDelBorrador: false, borradorEliminar: {}, cargandoBorrador: true, msgCargandoBorrador: 'Eliminando borrador...' });
    consulta(`api/v1.0/internacionalizacion/registro/${id}/eliminar_borrador`, {}, 'put', (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error && estado === 200) {
        tipo = 'success';
        titulo = resp.titulo;
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
        this.recargarBorradores(); // recarga la lista; si ya no quedan, cierra todo y vuelve
        return;
      } else {
        tipo = 'info';
        titulo = resp.titulo ? resp.titulo : mostrarError(resp);
        this.setState({ cargandoBorrador: false });
      }
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    });
  }

  recargarBorradores = () => {
    consulta('api/v1.0/internacionalizacion/registro/obtenerActividadBorrador', null, 'GET', (error, estado, resp) => {
      if (!error && estado === 200 && resp.borradores && resp.borradores.length > 0) {
        // Aún quedan borradores: actualizar la lista en el mismo modal
        this.setState({ borradorActividad: resp, cargandoBorrador: false });
      } else {
        // No quedan borradores (o error al recargar): cerrar todo y volver
        this.setState({ modalSeguirBorrador: false, cargandoBorrador: false });
        this.handleClose();
      }
    });
  }

  obtenerCantidadBorradores = async () => {
    let { actualizarMensaje, tipo_solicitud } = this.props;
    let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
    // Mostrar el cargando dentro del modal de borradores de inmediato (evita el salto brusco)
    this.setState({ cargandoBorrador: true, msgCargandoBorrador: 'Cargando...' });
    try {
      consulta(
        `api/v1.0/internacionalizacion/registro/obtenerCantidadBorradores?tipo_solicitud=${tipo_solicitud}`,
        null,
        'GET',
        (error, estado, resp) => {
          if (error) {
            this.setState({ cargandoBorrador: false });
            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
          } else {
            if (estado === 400) {
              this.setState({ cargandoBorrador: false });
              actualizarMensaje({
                titulo: resp.titulo,
                tipo: 'warning',
                mostrar: true,
                tiempo: 5000
              });
            } else {
              this.setState({ modalSeguirBorrador: false, isBorrador: false, cargandoBorrador: false });
              this.actualizarEstado('mostrarForm', true);
            }
          }
        }
      );
    } catch (error) {
      this.setState({ cargandoBorrador: false });
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    }
  }

  continuarConBorrador = async (borrador) => {
    let { borradorActividad } = this.state;
    const { actividad, registro_borrador } = borrador;
    

    const solicitudSelect = borradorActividad.registro_solicitud.find(
      solicitud => solicitud.id === registro_borrador.solicitud
    );
    
    const nuevoEstado = {
      solicitudSelect,
      departamento_docente: solicitudSelect.departamento_docente,
      programa_docente: solicitudSelect.programa_docente,
      tipo_actividad: actividad.tipo_actividad?.codigo || '',
      subtipo_actividad: actividad.subtipo_actividad?.codigo || '',
      instituciones: actividad.institucion_actividad,
      responsable_actividad: actividad.resp_actividad.map(resp => resp.codigo),
      administrativos_responsable: actividad.unidades_adm_resp.map(resp => resp.id),
      dpto_responsable: actividad.departamento_resp.map(resp => resp.id),
      facultad_responsable: actividad.facultad_resp.map(resp => resp.id),
      fecha_inicio: actividad.fecha_inicio,
      fecha_fin: actividad.fecha_final,
      titulo_tema: actividad.titulo_evento,
      descripcion_actividad: actividad.descripcion_actividad || '',
      resultados_descripcion: actividad.descripcion_resultados || '',
      mostrarForm: true,
      modalSeguirBorrador: false,
      isBorrador: true
    };
    
    if (actividad.info_complementaria) {
      const fileName = actividad.info_complementaria.split('/').pop();
      nuevoEstado.info_complementaria = fileName;
      nuevoEstado.info_complementaria_url = actividad.info_complementaria;
    }
    
    // Actualizar todo el estado de una vez
    this.setState(nuevoEstado);  
  };

  crearRegistroNuevo = () => {
    this.setState({ solicitudSelect: {}, id_solicitud_borrador: 0, isBorrador: false });
    this.obtenerCantidadBorradores();
    this.actualizarEstado('mostrarForm', true);
  };

  guardarActividadBorrador = async (data) => {
      let { actualizarMensaje, tipo_solicitud } = this.props;
      data.append('tipo_solicitud', tipo_solicitud);
      return new Promise((resolve) => {
          formulario(`api/v1.0/internacionalizacion/registro/actividadBorrador`, data, 'post', (error, estado, resp) => {
              let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error', ok = false;
              if (!error) {
                  if (estado === 200) {
                      tipo = 'success';
                      titulo = resp.titulo;
                      ok = true;
                      this.setState({ id_solicitud_borrador: resp.solicitud_id })
                  } else {
                      tipo = 'info';
                      titulo = resp.titulo ? resp.titulo : mostrarError(resp);
                  }
              }
              actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
              resolve(ok);
          });
      });
  }

  onSubmitActividBorrador = async () => {
    let { departamento_docente, programa_docente, instituciones, 
      tipo_actividad, subtipo_actividad, fecha_inicio, fecha_fin,
    responsable_actividad, administrativos_responsable, dpto_responsable, 
    facultad_responsable, titulo_tema, descripcion_actividad, 
    resultados_descripcion } = this.state;

    let data = new FormData();

    // Para arrays y objetos, convertirlos a JSON string
    data.append('departamento_docente', departamento_docente);
    data.append('programa_docente', programa_docente);
    data.append('instituciones', JSON.stringify(instituciones));
    data.append('tipo_actividad', tipo_actividad);
    data.append('subtipo_actividad', subtipo_actividad);
    data.append('fecha_inicio', moment(fecha_inicio).format("YYYY-MM-DD"));
    data.append('fecha_fin', moment(fecha_fin).format("YYYY-MM-DD"));
    data.append('responsable_actividad', JSON.stringify(responsable_actividad));
    data.append('administrativos_responsable', JSON.stringify(administrativos_responsable));
    data.append('dpto_responsable', JSON.stringify(dpto_responsable));
    data.append('facultad_responsable', JSON.stringify(facultad_responsable));
    data.append('titulo_tema', titulo_tema);
    data.append('descripcion_actividad', descripcion_actividad);
    data.append('resultados_descripcion', resultados_descripcion);

    // if (info_complementaria) {
    //   data.append('info_complementaria', info_complementaria_f);
    // }

    return await this.guardarActividadBorrador(data)
  }


  handleModalContenedor = async (codigo) => {
    return (
      <>
        {codigo === 'add_info_basica' && this.setState({ modalAddInfoBasica: true })}
        {codigo === 'add_financiacion' && this.setState({ modalAddFinanciacion: true })}
        {codigo === 'add_institucion' && this.setState({ modalAddInstitucion: true })}
      </>
    )
  }

  resetAll = () => {
    this.setState({ cargando: false, 
      modalAddRegistro: false, 
      enviando: false, 
      tipo_actividad: '', 
      subtipo_actividad: '', 
      otro_tipo_actividad: '', 
      otro_subtipo_actividad: '',
       fecha_inicio: null, 
       fecha_fin: null, 
       responsable_actividad: [], 
       dpto_responsable: [], 
       facultad_responsable: [], 
       administrativos_responsable: [], 
       titulo_tema: '', 
       descripcion_actividad: '', 
       resultados_descripcion: '', 
       info_complementaria: '', 
       info_complementaria_f: null, 
       participantes: [], 
       info_inicial_participantes: [], 
       financiacion_participantes: [], 
       institucion_participantes: [], 
       actividad_participantes: [], 
       instituciones: [], 
       tipo_movilidad: '', 
       tipo_modalidad: '', 
       plataforma: '', 
       otra_plataforma: '', 
       participantesSelect: [], 
       es_financiado: '', 
       tipo_financiacion: '', 
       dependencia: '', 
       fuente_financiacion: '', 
       entidad: '', 
       valor_cop: '', 
       tipo_moneda: '', 
       valor_ext: '', 
       clasificacion_de_financiacion: '', 
       otro_tipo_de_concepto: '', 
       comprobante_financiacion: '', 
       participante_tipo: null, 
       tipos_participantes: [], 
       tipo_participante: null, 
       errores: [], 
       institucion_participante: { id: 0, institucion: '', pais_vinculante: '', ciudad_vinculante: '' }, 
       facultad_participante: '', 
       nivel_participante: '', 
       programa_participante: '', 
       dpto_participante: '', 
       dependencia_participante: '', 
       actividad_participante: '', 
       activeStep: 0, 
       mostrarForm: false, 
       departamento_docente: '', 
       programa_docente: '', 
       info_complementaria_url: '',
       periodoSeleccionado: '',
       id_solicitud_borrador: 0,
       pertenece_red_academica: '',
       redAcademicaSelect: null,
       solicitudSelect: {}, borradorActividad: [], isBorrador: false,
       modalAddInstitucion: false, modal_buscar_institucion: false, modal_elimi_institucion: false });
  }

  handleClose = () => {
    this.resetAll();
    this.props.mostrarModalAddRegistro(false);
  };

  render() {
    let { modalAddRegistro, mostrarModalAddRegistro } = this.props;
    let { activeStep, participantes, 
      participantesSelect, 
      cargando, tit_cargando, 
      modalAddParticipante, 
      cargandoForm, errores, 
      modalDelParticipante, participante_quitar, 
      modalAddFinanciacion, modalAddInfoBasica, modalContenedor, 
      tipos_movilidades, tipos_modalidades, plataformas, 
      tipo_movilidad, tipo_modalidad, plataforma, otra_plataforma,  
      es_financiado, tipos_financiaciones, tipo_financiacion, dependencia, 
      dependencias, fuente_financiacion, fuentes_financiacion, entidad, 
      valor_cop, tipo_moneda, monedas, valor_ext, info_inicial_participantes, 
      tipos_conceptos, clasificacion_de_financiacion, otro_tipo_de_concepto, 
      comprobante_financiacion, modalAddParticipanteMasivo, modalDetParticipante,
       participanteDetalle, modalAddInstitucion, 
       institucion_participante, modal_buscar_institucion, 
       mostrarForm, participante_tipo, 
       masivos, enviando, financiaciones, nuevaFinanciacion, 
       mostrarFormulario, modalSeguirBorrador, borradorActividad, modalDelBorrador, borradorEliminar, cargandoBorrador, msgCargandoBorrador } = this.state;

    // PROPS PARA EL COMPONENTE DE INFORMACIÓN BÁSICA
    let props_info = { modalAddInfoBasica, cerrarModal: () => this.setState({ modalAddInfoBasica: false }), cargandoForm, errores, onChange: this.onChange, tipos_movilidades, tipos_modalidades, plataformas, tipo_movilidad, tipo_modalidad, plataforma, otra_plataforma, guardarInfoPrincipalParticipantes: this.guardarInfoPrincipalParticipantes }


    // PROPS PARA EL COMPONENTE DE FINANCIACIÓN
    let props_financiación = { participantesSelect, modalAddFinanciacion, cerrarModal: () => this.setState({ modalAddFinanciacion: false }), cargandoForm, onChange: this.onChange, es_financiado, tipos_financiaciones, tipo_financiacion, errores, dependencia, dependencias, fuente_financiacion, fuentes_financiacion, entidad, valor_cop, tipo_moneda, monedas, valor_ext, info_inicial_participantes, tipos_conceptos, clasificacion_de_financiacion, otro_tipo_de_concepto, fileInput: this.fileInput, comprobante_financiacion, guardarFinanciacionParticipantes: this.guardarFinanciacionParticipantes, financiaciones, agregarFinanciacion: this.agregarFinanciacion, onChangeFinanciaciones: this.onChangeFinanciaciones, nuevaFinanciacion, mostrarFormulario, mostrarFormularioNuevaFinanciacion: this.mostrarFormularioNuevaFinanciacion, eliminarFinanciacion: this.eliminarFinanciacion, buscarDataFinanciacion: this.buscarDataFinanciacion }

    // PROPS PARA EL COMPONENTE DE INSTITUCIÓN
    let props_institucion = { modalAddInstitucion, cerrarModal: () => this.setState({ modalAddInstitucion: false }), cargandoForm, errores, institucion_participante, modal_buscar_institucion, agregarInstitucionParticipante: this.agregarInstitucionParticipante, cerrarModalBuscarInstitucion: () => this.setState({ modal_buscar_institucion: false }), abrirBuscarInst: () => this.setState({ modal_buscar_institucion: true }), participante_tipo }

    return (
      <>
        <Dialog fullWidth={true} maxWidth={(participantes && participantes.length > 0 && activeStep == 1) ? 'lg' : 'md'} open={modalAddRegistro} onClose={() => this.handleClose()} disableBackdropClick={true}>
          <AppBarModal titulo={'¡ Agregar Registro de Movilidad !'} mostrarModal={() => this.handleClose()} />
          {
            !cargando ?
              <DialogContent className='scroll'>
                <Grid container justifyContent='center'>
                  {mostrarForm &&
                    <Grid item xs={9} md={9}>
                      <Stepper activeStep={activeStep}>
                        {
                          configStep.map(label => (
                            <Step key={label}>
                              <StepLabel><p>{label}</p></StepLabel>
                            </Step>
                          ))
                        }
                      </Stepper>
                    </Grid>
                  }
                  <Grid item xs={12}>
                    {this.configStepContent()}
                  </Grid>
                </Grid>
              </DialogContent>
              : <TareasTerminadas mensaje={tit_cargando} marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />
          }
          <DialogActions>
            {
              activeStep === 0 && mostrarForm &&
              <>
                <BtnForm texto="CERRAR" callback={() => this.handleClose()} />
                <BtnForm texto="SIGUIENTE" callback={() => this.handleStep()} />
              </>
            }
            {
              activeStep === 1 &&
              <>
                <BtnForm texto="CERRAR" callback={() => mostrarModalAddRegistro(false)} />
                <BtnForm texto="REGRESAR" callback={() => this.setState({ activeStep: activeStep - 1 })} />
                <BtnForm texto="SIGUIENTE" callback={() => this.handleStep()} />
              </>
            }
            {
              activeStep === 2 && !enviando &&
              <>
                <BtnForm texto="CERRAR" callback={() => mostrarModalAddRegistro(false)} />
                <BtnForm texto="REGRESAR" callback={() => this.setState({ activeStep: activeStep - 1 })} />
                <BtnForm texto="FINALIZAR" callback={() => document.getElementById('enviar_form_multi_archivo').click()} />
              </>
            }
            {/* <>
              <BtnForm texto="CERRAR" callback={() => mostrarModalAddRegistro(false)} />
              <BtnForm texto="GUARDAR" callback={() => this.submitForm()} />
            </> */}
          </DialogActions>
        </Dialog>

        {/* MODAL CONTENEDOR */}
        {modalContenedor && <ModalContenedor state={this.state} actions={this} />}

        {/* AÑADIR PARTICIPANTE */}
        {modalAddParticipante && <AgregarParticipante state={this.state} actions={this} editar={false} />}


        {/* AÑADIR INFORMACIÓN BÁSICA */}
        {modalAddInfoBasica && <AgregarInfoBasica props_info={props_info} />}

        {/* AÑADIR FINANCIACIÓN */}
        {modalAddFinanciacion && <AgregarFinanciacion props_financiación={props_financiación} />}

        {/* AÑADIR INSTITUCIÓN */}
        {modalAddInstitucion && <AgregarInstitucion state={this.state} actions={this} props_institucion={props_institucion} />}

        {/* AÑADIR PARTICIPANTES MASIVOS */}
        {modalAddParticipanteMasivo && <AgregarParticipanteMasivo modalMasivo={modalAddParticipanteMasivo} cerrarModal={() => this.setState({ modalAddParticipanteMasivo: false })} enviarParticipantesMasivo={this.enviarParticipantesMasivo} masivos={masivos} ca />}

        {/* DETALLE PARTICIPANTE */}
        {modalDetParticipante && <DetalleParticipante modalDetParticipante={modalDetParticipante} cerrarModal={() => this.setState({ modalDetParticipante: false })} participanteDetalle={participanteDetalle} cargando={false} cargandoForm={cargandoForm} />}
        
        {modalSeguirBorrador && (
        <Dialog
          fullWidth
          maxWidth="md"
          open={modalSeguirBorrador}
          disableBackdropClick={true}
          onClose={() => this.setState({ modalSeguirBorrador: false })}
          PaperProps={{
            style: {
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
            }
          }}
        >
        <AppBarModal 
          titulo="Borradores disponibles" 
          mostrarModal={() => this.setState({ modalSeguirBorrador: false })}
        />
        <DialogContent dividers style={{ padding: '24px' }}>
          {cargandoBorrador ? (
            <TareasTerminadas mensaje={msgCargandoBorrador || 'Cargando...'} marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />
          ) : (
          <>
          <Box sx={{ mb: 3, textAlign: 'center' }}>
            <InfoIcon style={{ fontSize: 48, color: '#1976d2', marginBottom: '8px' }} />
            <Typography variant="h6" style={{ fontWeight: 500 }}>
              Se han encontrado {borradorActividad?.borradores.length || 0} registros en borrador
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Selecciona un borrador para continuar o crea un nuevo registro
            </Typography>
          </Box>

          {borradorActividad && borradorActividad.borradores.length > 0 ? (
            <TableContainer component={Paper} elevation={0} variant="outlined">
              <Table>
                <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell><Typography variant="subtitle2">Título evento</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2">Tipo - subtipo actvidad</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2">Fecha creación</Typography></TableCell>
                    <TableCell align="center"><Typography variant="subtitle2">Acción</Typography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {borradorActividad.borradores.map((borrador) => (
                    <TableRow 
                      key={borrador.registro_borrador.id}
                      hover
                    >
                      <TableCell>
                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                          {borrador.actividad.titulo_evento || 'Sin título'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={`${borrador.actividad.tipo_actividad?.nombre || ''} - ${borrador.actividad.subtipo_actividad?.nombre || ''}`}
                          color="primary"
                          variant="outlined"
                        />
                      </TableCell>                     
                      <TableCell>
                        <Tooltip title={new Date(borrador.registro_borrador.fecha_registro).toLocaleString()}>
                          <Typography variant="body2">
                            {new Date(borrador.registro_borrador.fecha_registro).toLocaleDateString()}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => {
                            this.continuarConBorrador(borrador);
                            this.setState({ modalSeguirBorrador: false, isBorrador: true });
                          }}
                        >
                          Continuar
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          style={{ marginLeft: '8px' }}
                          onClick={() => this.setState({ modalDelBorrador: true, borradorEliminar: { id: borrador.registro_borrador.solicitud } })}
                        >
                          Eliminar
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Alert severity="info" sx={{ mb: 2 }}>No hay borradores disponibles</Alert>
          )}
          </>
          )}
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', justifyContent: 'space-between' }}>
          <Button
            style={{ 
              borderRadius: '20px', 
              padding: '8px 16px',
              textTransform: 'none',
            }}
            variant="outlined"
            color="error"
            disabled={cargandoBorrador}
            onClick={() => this.setState({ modalSeguirBorrador: false })}
          >
            Cancelar
          </Button>
          <Button
            style={{ 
              borderRadius: '20px', 
              padding: '8px 20px',
              textTransform: 'none',
              color: 'white',
              boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)'
            }}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            disabled={cargandoBorrador}
            onClick={() => {
              this.obtenerCantidadBorradores();
            }}
          >
            Crear nuevo registro
          </Button>
        </DialogActions>
      </Dialog>
        
        )}
        

        {/* CONFIRMAR ELIMINAR PARTICIPANTE */}
        <ConfirmarAccion
          mensaje1={
            <React.Fragment>
              ¿Estás seguro de quitar a <b>{participante_quitar.primer_nombre} {participante_quitar.segundo_nombre} {participante_quitar.primer_apellido} {participante_quitar.segundo_apellido}</b> de la lista de participantes?
              <br />
              {/* <Alert severity="info" variant="outlined"> */}
              Recuerda que si eliminas al participante, se eliminará la información guardada.
              {/* </Alert> */}
            </React.Fragment>
          }
          ejecutarAccion={this.quitarParticipante}
          mostrarModalConfAccion={(modalDelParticipante) => this.setState({ modalDelParticipante })}
          modalConAccion={modalDelParticipante}
          dato={{ id: 0 }}
          titulo={'¿ Quitar participante ?'}
          mensaje2={''}
        />

        {/* CONFIRMAR ELIMINAR BORRADOR */}
        <ConfirmarAccion
          mensaje1={'El borrador seleccionado será eliminado, esta acción no se puede deshacer. '}
          ejecutarAccion={this.eliminarBorrador}
          mostrarModalConfAccion={(modalDelBorrador) => this.setState({ modalDelBorrador })}
          modalConAccion={modalDelBorrador}
          dato={borradorEliminar}
          titulo={'¿ Eliminar borrador ?'}
          mensaje2={''}
        />



      </>
    )
  }


}

export default RegistroCrear;